// Calendar Create
const CALENDAR_ADD_REQUEST = 'CALENDAR_ADD_REQUEST';
const CALENDAR_ADD_SUCCESS = 'CALENDAR_ADD_SUCCESS';
const CALENDAR_ADD_FAILURE = 'CALENDAR_ADD_FAILURE';
// Calendar

const HOSPITAL_PHARMACY_CALENDAR_REQUEST = 'HOSPITAL_PHARMACY_CALENDAR_REQUEST';
const HOSPITAL_PHARMACY_CALENDAR_SUCCESS = 'HOSPITAL_PHARMACY_CALENDAR_SUCCESS';
const HOSPITAL_PHARMACY_CALENDAR_FAILURE = 'HOSPITAL_PHARMACY_CALENDAR_FAILURE';

// calendar Update

const CALENDAR_UPDATE_REQUEST = 'CALENDAR_UPDATE_REQUEST';
const CALENDAR_UPDATE_SUCCESS = 'CALENDAR_UPDATE_SUCCESS';
const CALENDAR_UPDATE_FAILURE = 'CALENDAR_UPDATE_FAILURE';


export {
    CALENDAR_ADD_REQUEST,
    CALENDAR_ADD_SUCCESS,
    CALENDAR_ADD_FAILURE,
    HOSPITAL_PHARMACY_CALENDAR_REQUEST,
    HOSPITAL_PHARMACY_CALENDAR_SUCCESS,
    HOSPITAL_PHARMACY_CALENDAR_FAILURE,
    CALENDAR_UPDATE_REQUEST,
    CALENDAR_UPDATE_SUCCESS,
    CALENDAR_UPDATE_FAILURE
};